import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import ModalPortal from '../../components/modal-portal';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { errorModalMessages } from './messages';
import style from './split-ship-modal.module.less';

export const MissingLinksErrorModal = ({ onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal size='small'>
        <ModalHeader onClose={onClose}>
          <FormattedMessage {...errorModalMessages.errorModalTitle} />
        </ModalHeader>
        <ModalBody className={style.body}>
          <p className={style.instructions}>
            <FormattedMessage {...errorModalMessages.errorModalBody} />
          </p>
        </ModalBody>
        <ModalFooter>
          <ModalFooterCancelButton onClose={onClose} />
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

MissingLinksErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
